import FolderIcon from "@mui/icons-material/Folder";
import LogoutIcon from "@mui/icons-material/Logout";
import { DocumentCheckIcon } from "@heroicons/react/24/outline";
import axios from "axios";
import { Link, useParams, useLocation } from "react-router-dom";

const backEndUrl = process.env.REACT_APP_SERVER_ADDRESS;

const handleLogout = async () => {
  await axios({ method: "POST", url: `${backEndUrl}/auth/logout`, withCredentials: true }).catch(() => {});
  window.location.href = "/my-account";
};

const SidebarClient = (props) => {
  const { id } = useParams();
  const location = useLocation();
  const isActive = location.pathname.startsWith(`/upload/`);

  return (
    <aside className="w-56 shrink-0 bg-white h-screen sticky top-0 flex flex-col justify-between border-r border-slate-100 shadow-sm z-20">

      {/* Top */}
      <div className="px-5 py-5">
        {/* Logo */}
        <div className="flex items-center gap-3 px-2 mb-8">
          <div className="w-9 h-9 bg-gradient-to-br from-sky-400 to-sky-600 rounded-xl flex items-center justify-center text-white shadow-lg shadow-sky-200 shrink-0">
            <DocumentCheckIcon className="h-5 w-5" />
          </div>
          <div className="min-w-0">
            <span className="text-xl font-bold text-slate-800 tracking-tight block leading-none">{props.companyName || "ImmiSpace"}</span>
            <span className="text-[10px] text-slate-400 tracking-wide uppercase font-medium mt-0.5 block">Client Portal</span>
          </div>
        </div>

        {/* Nav */}
        <nav className="space-y-1">
          <Link
            to={`/upload/${id}`}
            className={`group flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all ${
              isActive ? "bg-sky-50" : "hover:bg-slate-50"
            }`}
          >
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center transition-colors shadow-sm ${
              isActive
                ? "bg-sky-500 text-white"
                : "bg-white border border-slate-200 text-slate-400 group-hover:border-sky-200 group-hover:text-sky-500"
            }`}>
              <FolderIcon fontSize="small" />
            </div>
            <span className={`text-sm font-semibold ${
              isActive ? "text-sky-900" : "text-slate-600 group-hover:text-slate-900"
            }`}>
              Documents
            </span>
          </Link>
        </nav>
      </div>

      {/* Bottom – sign out */}
      <div className="p-5 border-t border-slate-100">
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-slate-400 hover:text-red-500 hover:bg-red-50 transition-all group"
        >
          <div className="w-8 h-8 rounded-lg bg-white border border-slate-200 flex items-center justify-center group-hover:border-red-200 group-hover:text-red-400 transition-colors">
            <LogoutIcon fontSize="small" />
          </div>
          <span className="text-sm font-semibold">Sign out</span>
        </button>
      </div>

    </aside>
  );
};

export default SidebarClient;
